import React, { useState, useEffect } from 'react';

var deferredPrompt = null;

function PWAInstallPrompt() {
  var [show, setShow] = useState(false);
  var [isIOS, setIsIOS] = useState(false);
  var [dismissed, setDismissed] = useState(false);

  useEffect(function() {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    if (window.navigator.standalone === true) return;

    // Check if dismissed recently
    var dismissedAt = localStorage.getItem('pwa_dismissed');
    if (dismissedAt && Date.now() - Number(dismissedAt) < 7 * 24 * 60 * 60 * 1000) return;

    // iOS detection
    var ua = window.navigator.userAgent;
    var isiOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    setIsIOS(isiOS);

    if (isiOS) {
      // Show iOS instructions after a delay
      setTimeout(function() { setShow(true); }, 3000);
      return;
    }

    // Android/Desktop: listen for beforeinstallprompt
    var handler = function(e) {
      e.preventDefault();
      deferredPrompt = e;
      setTimeout(function() { setShow(true); }, 2000);
    };
    window.addEventListener('beforeinstallprompt', handler);

    return function() { window.removeEventListener('beforeinstallprompt', handler); };
  }, []);

  var handleInstall = async function() {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    var result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      setShow(false);
    }
    deferredPrompt = null;
  };

  var handleDismiss = function() {
    setShow(false);
    setDismissed(true);
    localStorage.setItem('pwa_dismissed', String(Date.now()));
  };

  if (!show || dismissed) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 20, left: 20, right: 20, maxWidth: 400, margin: '0 auto',
      background: '#12121f', borderRadius: 16, padding: '20px', border: '1px solid #2a2a4a',
      boxShadow: '0 16px 60px rgba(0,0,0,0.5)', zIndex: 9999,
      animation: 'slideUp 0.4s ease-out',
    }}>
      <style>{`
        @keyframes slideUp { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>

      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
        <div style={{
          width: 44, height: 44, borderRadius: 12, flexShrink: 0,
          background: 'linear-gradient(135deg, #ff6b2b, #ffab40)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 16, fontWeight: 800, color: '#fff',
        }}>iV</div>

        <div style={{ flex: 1 }}>
          <h3 style={{ color: '#fff', fontSize: 15, fontWeight: 700, margin: '0 0 4px' }}>
            Install IVision Marketing
          </h3>

          {isIOS ? (
            <p style={{ color: '#888', fontSize: 13, margin: 0, lineHeight: 1.5 }}>
              Tap <span style={{ color: '#fff', fontWeight: 600 }}>Share</span> then <span style={{ color: '#fff', fontWeight: 600 }}>Add to Home Screen</span> for the full app experience.
            </p>
          ) : (
            <p style={{ color: '#888', fontSize: 13, margin: 0, lineHeight: 1.5 }}>
              Add to your home screen for quick access and a native app experience.
            </p>
          )}

          <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
            {!isIOS && (
              <button onClick={handleInstall} style={{
                padding: '9px 20px', background: 'linear-gradient(135deg, #ff6b2b, #ffab40)',
                color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer',
              }}>Install</button>
            )}
            <button onClick={handleDismiss} style={{
              padding: '9px 16px', background: '#1e1e35', color: '#888',
              border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer',
            }}>{isIOS ? 'Got it' : 'Not now'}</button>
          </div>
        </div>

        <button onClick={handleDismiss} style={{
          background: 'none', border: 'none', color: '#555', fontSize: 18,
          cursor: 'pointer', padding: '0 4px', lineHeight: 1,
        }}>&times;</button>
      </div>
    </div>
  );
}

export default PWAInstallPrompt;
